import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'folder-icon',
  templateUrl: './folder-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FolderIconComponent {}
